// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"bQl5O":[function(require,module,exports) {
require("2d969f6eb58129e4").register(require("b44761bba9809cfc").getBundleURL("d37tl"), JSON.parse('["d37tl","shoppingList.b41305b6.js","6pYmK","../icons.7bb96926.svg","4vDYv","../index.1b5fdb01.js"]'));

},{"2d969f6eb58129e4":"44XlC","b44761bba9809cfc":"7Ve2W"}],"44XlC":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"7Ve2W":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"1po2q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _webImmediateJs = require("core-js/modules/web.immediate.js");
var _modelJs = require("./model.js");
var _runtime = require("regenerator-runtime/runtime");
var _listViewJs = require("./views/listView.js");
var _listViewJsDefault = parcelHelpers.interopDefault(_listViewJs);
var _formViewJs = require("./views/formView.js");
var _formViewJsDefault = parcelHelpers.interopDefault(_formViewJs);
var _themeViewJs = require("./views/themeView.js");
var _themeViewJsDefault = parcelHelpers.interopDefault(_themeViewJs);
const controlDownload = function() {
    if (!_modelJs.state.ingredientsList[0]) return;
    // Create a new style element
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
    .list__shopping-list, .list__item { color: black; background-color: white; }
    .list__options { display: none; }
  `;
    document.head.appendChild(style);
    const opt = {
        margin: 1,
        filename: "shoppingList.pdf",
        image: {
            type: "jpeg",
            quality: 0.98
        },
        html2canvas: {
            scale: 2
        },
        jsPDF: {
            unit: "in",
            format: "letter",
            orientation: "portrait"
        }
    };
    // Generate PDF
    html2pdf().set(opt).from((0, _listViewJsDefault.default).listToDownload).toPdf().get("pdf").save().then(function() {
        // Remove the injected style after generating the PDF
        document.head.removeChild(style);
    });
};
const controlList = function() {
    if (!_modelJs.state.ingredientsList[1]) return;
    (0, _listViewJsDefault.default).render(_modelJs.state.ingredientsList);
};
const controlClearList = function(view) {
    // if (!model.state.ingredientsList[1]) return;
    _modelJs.clearIngredients();
    if (view === "listView") (0, _listViewJsDefault.default).renderMessageInsideList();
    if (view === "formView") (0, _formViewJsDefault.default).clearForm();
};
const controlResetList = function() {
    // if (!model.state.ingredientsList[1]) return;
    _modelJs.clearIngredients();
    (0, _formViewJsDefault.default).clearForm();
    (0, _listViewJsDefault.default).render(_modelJs.state.ingredientsList);
    (0, _listViewJsDefault.default).renderMessageInsideList();
};
const controlCheckItem = function(ingredient) {
    // console.log(ingredient);
    _modelJs.removeIngredient(ingredient);
    if (!_modelJs.state.ingredientsList[1]) {
        (0, _listViewJsDefault.default).renderMessageInsideList();
        return;
    }
    (0, _listViewJsDefault.default).render(_modelJs.state.ingredientsList);
};
const controlEditList = function() {
    if (!_modelJs.state.ingredientsList[1]) {
        (0, _formViewJsDefault.default).render([
            "",
            ""
        ]);
        return;
    }
    (0, _formViewJsDefault.default).render(_modelJs.state.ingredientsList);
};
const controlRemoveItem = function(item) {
    (0, _formViewJsDefault.default).removeListItem(item);
};
const controlAddItem = function() {
    (0, _formViewJsDefault.default).addListItem();
};
const controlSubmitForm = function(formData) {
    // console.log(formData);
    _modelJs.submitListData(formData);
    if (!_modelJs.state.ingredientsList[1]) {
        (0, _listViewJsDefault.default).renderMessageInsideList();
        return;
    }
    (0, _listViewJsDefault.default).render(_modelJs.state.ingredientsList);
};
const controlTheme = function(actualTheme) {
    let newTheme = "light";
    if (actualTheme === "light") newTheme = "dark";
    _modelJs.changeTheme(newTheme);
    (0, _themeViewJsDefault.default).setTheme(newTheme);
};
const initTheme = function() {
    (0, _themeViewJsDefault.default).setTheme(_modelJs.state.theme);
};
const init = function() {
    (0, _listViewJsDefault.default).addHandlerRenderList(controlList);
    (0, _listViewJsDefault.default).addHandlerCheck(controlCheckItem);
    (0, _listViewJsDefault.default).addHandlerDownload(controlDownload);
    (0, _listViewJsDefault.default).addHandlerEditList(controlEditList);
    (0, _listViewJsDefault.default).addHandlerClear(controlClearList);
    (0, _listViewJsDefault.default).addHandlerReset(controlResetList);
    (0, _formViewJsDefault.default).addHandlerClear(controlClearList);
    (0, _formViewJsDefault.default).addHandlerAddItem(controlAddItem);
    (0, _formViewJsDefault.default).addHandlerRemoveItem(controlRemoveItem);
    (0, _formViewJsDefault.default).addHandlerSubmit(controlSubmitForm);
    (0, _formViewJsDefault.default).addHandlerDragover();
    (0, _formViewJsDefault.default).addHandlerDragstart();
    (0, _formViewJsDefault.default).addHandlerDragend();
    (0, _formViewJsDefault.default).addHandlerOnFocus();
    (0, _formViewJsDefault.default).addHandlerOnBlur();
    (0, _themeViewJsDefault.default).addHandlerChangeTheme(controlTheme);
    initTheme();
};
init();

},{"core-js/modules/web.immediate.js":"b7Fhu","./model.js":"5XrL7","regenerator-runtime/runtime":"j1Ujo","./views/listView.js":"6Ncp6","./views/formView.js":"hq7Fo","./views/themeView.js":"htPRE","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"6Ncp6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewJs = require("./View.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _iconsSvg = require("url:../../img/icons.svg");
var _iconsSvgDefault = parcelHelpers.interopDefault(_iconsSvg);
class ListView extends (0, _viewJsDefault.default) {
    // _parentElement = document.querySelector('.list__shopping-list');
    _parentElement = document.querySelector(".list__list-container");
    _message = "Choose a recipe and start adding some ingredients to your shopping list or click 'Edit' to add your own items!";
    _buttonClear = document.querySelector(".list__btn-delete");
    _buttonDownload = document.querySelector(".list__btn-download");
    _buttonEdit = document.querySelector(".list__btn-edit");
    _buttonNav = document.querySelector(".page-options__btn--reset");
    listToDownload = document.getElementById("list");
    addHandlerRenderList(handler) {
        window.addEventListener("load", handler);
        this.renderMessageInsideList();
    }
    addHandlerReset(handler) {
        this._buttonNav.addEventListener("click", function() {
            handler();
        });
    }
    addHandlerCheck(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--check");
            if (!btn) return;
            const ingredient = e.target.closest(".list__item").querySelector(".list__ing").innerText;
            handler(ingredient);
        });
    }
    addHandlerClear(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".list__btn-delete");
            if (!btn) return;
            handler("listView");
        });
    }
    addHandlerDownload(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".list__btn-download");
            if (!btn) return;
            handler();
        });
    }
    addHandlerEditList(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".list__btn-edit");
            if (!btn) return;
            handler();
        });
    }
    _generateMarkup() {
        return ` 
    <h3 class="list__title"><span>${this._data[0]}</span></h3>
    
    <ul class="list__shopping-list">
    ${this._data.slice(1).map(this._generateMarkupItem).join("")}
    </ul>

    <div class="list__options">
                <button class="btn--list list__btn-edit">
                  <svg class="list__icon">
                    <use href="${0, _iconsSvgDefault.default}#icon-edit-pencil"></use>
                  </svg>
                </button>
                <button class="btn--list list__btn-delete">
                  <svg class="list__icon">
                    <use href="${0, _iconsSvgDefault.default}#icon-bin"></use>
                  </svg>
                </button>
                <button class="btn--list list__btn-download">
                  <svg class="list__icon">
                    <use href="${0, _iconsSvgDefault.default}#icon-download"></use>
                  </svg>
                </button>
              </div>
    `;
    }
    _generateMarkupItem(item) {
        return `
    <li class="list__item">
    <div class="list__ing">${item}</div>
    <div class="list__item-buttons">
      <button class="btn--tiny btn--check">
        <svg>
          <title>Check</title>
          <use href="${0, _iconsSvgDefault.default}#icon-checkmark"></use>
        </svg>
      </button>
    </div>
  </li>
    `;
    }
    renderMessageInsideList(message = this._message) {
        const markup = `
    <h3 class="list__title"><span>MY SHOPPING LIST</span></h3>

    <ul class="list__shopping-list" id="list">
      <div class="message">
        <div>
          <svg>
            <use href="${(0, _iconsSvgDefault.default)}#icon-smile"></use>
           </svg>
        </div>
         <p>${message}</p>
        </div>
    </ul>

    <div class="list__options">
      <button class="btn--list list__btn-edit">
        <svg class="list__icon">
          <use href="${(0, _iconsSvgDefault.default)}#icon-edit-pencil"></use>
        </svg>
      </button>
      <button class="btn--list list__btn-delete">
        <svg class="list__icon">
          <use href="${(0, _iconsSvgDefault.default)}#icon-bin"></use>
        </svg>
      </button>
      <button class="btn--list list__btn-download">
        <svg class="list__icon">
          <use href="${(0, _iconsSvgDefault.default)}#icon-download"></use>
        </svg>
      </button>
    </div>
      `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}
exports.default = new ListView();

},{"./View.js":"lslfl","url:../../img/icons.svg":"9yZmu","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"9yZmu":[function(require,module,exports) {
module.exports = require("6cfd6703c689ebb2").getBundleURL("d37tl") + "../icons.7bb96926.svg";

},{"6cfd6703c689ebb2":"7Ve2W"}],"hq7Fo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewJs = require("./View.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _iconsSvg = require("url:../../img/icons.svg");
var _iconsSvgDefault = parcelHelpers.interopDefault(_iconsSvg);
class FormView extends (0, _viewJsDefault.default) {
    _parentElement = document.querySelector(".list__list-container");
    // Form handlers
    addHandlerSubmit(handler) {
        this._parentElement.addEventListener("click", function(e) {
            e.preventDefault();
            const btn = e.target.closest(".list__btn-submit");
            if (!btn) return;
            const formData = [
                ...new FormData(this.querySelector("form"))
            ];
            handler(formData);
        });
    }
    addHandlerAddItem(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".list__btn-add");
            if (!btn) return;
            handler();
        });
    }
    addHandlerClear(handler) {
        this._parentElement.parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".list__btn-clear-form");
            if (!btn) return;
            handler("formView");
        });
    }
    addHandlerRemoveItem(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--discard");
            if (!btn) return;
            const item = e.target.closest(".list__item");
            handler(item);
        });
    }
    // Event delegation for clearing the dragging on input focus
    addHandlerOnFocus() {
        this._parentElement.addEventListener("onfocusin", function(e) {
            const input = e.target.closest(".form__input");
            if (!input) return;
            input.parentNode.setAttribute("draggable", false);
            console.log(input.parentNode);
        });
    }
    addHandlerOnBlur() {
        this._parentElement.addEventListener("onfocusout", function(e) {
            const input = e.target.closest(".form__input");
            if (!input) return;
            input.parentNode.setAttribute("draggable", true);
            console.log(input.parentNode);
        });
    }
    // Drag and drop events for list items
    addHandlerDragover() {
        this._parentElement.addEventListener("dragover", this._dragover.bind(this));
    }
    addHandlerDragstart() {
        this._parentElement.addEventListener("dragstart", function(e) {
            const draggable = e.target.closest(".list__item--draggable");
            if (!draggable) return;
            draggable.classList.add("list__item--draggable-dragging");
        });
    }
    addHandlerDragend() {
        this._parentElement.addEventListener("dragend", function(e) {
            const draggable = e.target.closest(".list__item--draggable");
            if (!draggable) return;
            draggable.classList.remove("list__item--draggable-dragging");
        });
    }
    //Drag and drop helpers
    _dragover(e) {
        e.preventDefault();
        const container = e.target.closest(".list__shopping-list");
        if (!container) return;
        const afterElement = this._getDragAfterElement(container, e.clientY);
        const draggable = document.querySelector(".list__item--draggable-dragging");
        if (afterElement == null) container.appendChild(draggable);
        else container.insertBefore(draggable, afterElement);
    }
    _getDragAfterElement(container, y) {
        const draggableEls = [
            ...container.querySelectorAll(".list__item--draggable:not(.list__item--draggable-dragging)")
        ];
        return draggableEls.reduce((closest, child)=>{
            const box = child.getBoundingClientRect();
            const offset = y - box.top - box.height / 2;
            if (offset < 0 && offset > closest.offset) return {
                offset: offset,
                element: child
            };
            else return closest;
        }, {
            offset: Number.NEGATIVE_INFINITY
        }).element;
    }
    // Form actions functions
    addListItem() {
        const markup = this._generateInputField();
        this._parentElement.querySelector(".list__shopping-list").insertAdjacentHTML("beforeend", markup);
    }
    removeListItem(item) {
        this._parentElement.querySelector(".list__shopping-list").removeChild(item);
    }
    clearForm() {
        let listToClear = this._parentElement.querySelector(".list__shopping-list");
        listToClear.innerHTML = "";
        this.addListItem();
    }
    //Functions for rendering
    _generateMarkup() {
        return `
    <form>
    <h3 class="list__title list__title--form"><span><input placeholder="My shopping list" class="form__title" name="title" value="${this._data[0]}"></input></span></h3>

    
    <ul class="list__shopping-list">
      ${this._data.slice(1).map((item)=>this._generateInputField(item)).join("")}
    </ul>
    </form>
    <div class="list__options form__buttons">
      <button class="btn--list list__btn-add">
        <svg class="list__icon list__icon--add">
          <use href="${0, _iconsSvgDefault.default}#icon-plus"></use>
        </svg>
      </button>
      <button class="btn--list list__btn-clear-form">
        <svg class="list__icon">
          <use href="${0, _iconsSvgDefault.default}#icon-bin"></use>
        </svg>
      </button>
      <button class="btn--list list__btn-submit">
        <svg class="list__icon">
          <use href="${0, _iconsSvgDefault.default}#icon-checkmark"></use>
        </svg>
      </button>
    </div>
    `;
    }
    _generateInputField(item = "") {
        return `
    <li class="list__item list__item--draggable" draggable="true">
      <input class="list__ing form__input" placeholder="Your item here" name="item" value="${item}"></input>
      <div class="list__item-buttons">
        <button class="btn--tiny btn--discard">
         <svg>
            <use href="${0, _iconsSvgDefault.default}#icon-minus"></use>
          </svg>
        </button>
      </div>
    </li>
    `;
    }
}
exports.default = new FormView();

},{"./View.js":"lslfl","url:../../img/icons.svg":"9yZmu","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}]},["bQl5O","1po2q"], "1po2q", "parcelRequire3a11")

//# sourceMappingURL=shoppingList.b41305b6.js.map
